import { useAtomValue } from 'jotai';
import type { GroupLicensePermissionType } from 'balus-common';
import { groupLicensePermissionsAtom } from './GroupLicensePermissionsAtom';

export const useGroupLicensePermissions = (): GroupLicensePermissionType | null => {
  return useAtomValue(groupLicensePermissionsAtom);
};
